export default {
  relics: 'Relics',
  museum: 'Museum',
  battery: 'Relic battery',
  glyph: {
    title: 'Glyph: {0}',
    noLevel: 'Add a relic with this glyph to a pedestal to raise the level of this glyph',
    speedOvercap: 'You have more glyphs assigned than needed to level up, making this glyph level up x{0} faster',
    speedBonus: 'You have {0} bonus glyphs from other pedestals, increasing level up speed by x{1}',
    dust: 'Dust',
    clay: 'Clay',
    heat: 'Heat',
    wood: 'Wood',
    flow: 'Flow',
    stone: 'Stone',
    spike: 'Spike',
    dream: 'Dream',
    clover: 'Clover',
    rain: 'Rain',
    sun: 'Sun',
    cloud: 'Cloud',
    blossom: 'Blossom',
    leaf: 'Leaf',
    paper: 'Paper',
    book: 'Book',
    coin: 'Coin',
    card: 'Card',
  },
  pedestal: {
    modify: 'Modify pedestals',
    modifyDescription: 'Changing any pedestal resets the current level progress for all glyphs, so think carefully before you make any changes',
    unsavedChanges: 'Changes to pedestals do not apply until you confirm them by clicking "{0}"',
  },

  torch: {
    name: 'Torch',
    active: 'Illuminate',
    description: 'Remove depth restrictions',
    formula: 'Select a depth. For the rest of the run, salt and ores become available (with 50% gain) at this depth, as long as the minimum depth is reached',
  },
  purpleHeart: {name: 'Purple heart'},
  dustyBook: {name: 'Dusty book'},
  rottenLeaf: {name: 'Rotten leaf'},
  stonepiercer: {
    name: 'Stonepiercer',
    active: 'Shatter',
    description: 'Apply maximum breaks everywhere',
    formula: 'For each depth, take the highest amount of breaks of all depths below. Gain niter from breakpoints by doing this ({0})',
  },
  consolationPrize: {name: 'Consolation prize'},
  prettyLamp: {name: 'Pretty lamp'},
  museumKey: {name: 'Museum key'},
  ribbon: {name: 'Ribbon'},
  copier: {name: 'Copier'},
  deckOfCards: {name: 'Deck of cards'},
  chessboard: {name: 'Chess board'},
  iridiscentFlower: {name: 'Iridiscent flower'},
  scienceBook: {name: 'Science book'},
  hugeDiamond: {name: 'Huge diamond'},

  excavator: {name: 'Excavator'},
  redCard: {name: 'Red card'},
  briefcase: {name: 'Briefcase'},
  strangePlant: {name: 'Strange plant'},
  beneficialVirus: {name: 'Beneficial virus'},
  shapeCollection: {
    name: 'Shape collection',
    active: 'AI Art',
    description: 'Autocollect {0} shapes',
    formula: 'Spend {0} motivation (up to {1}) to automatically collect {2} shapes. This does not change the current shape grid'
  },
  stonePillar: {name: 'Stone pillar'},
  fieryRuby: {name: 'Fiery ruby'},

  notebook: {
    name: 'Notebook',
    active: 'Copy homework',
    description: 'Gain {0} total points',
    formula: 'Increase your total points by {0}, or use an exam pass to gain {1} total points instead (General quests only)'
  },

  friendlyBat: {
    name: 'Friendly bat',
    active: 'Echolocate',
    description: 'Receive {0} scrap instantly',
    formula: 'Based on highest amount of scrap owned ({0}) and 20 minutes of scrap income at the deepest completed depth ({1})',
  },
  honeyPot: {
    name: 'Pot of honey',
    active: 'Swarm of bees',
    description: 'Fully refill your resin',
    formula: 'Gain resin equal to your resin capacity ({0})',
  },

  mudBrick: {name: 'Mud brick'},
  sapling: {name: 'Sapling'},
  keychain: {
    name: 'Keychain',
    active: 'Tax collection',
    description: 'Receive {0} gold coins instantly',
    formula: 'Based on highest amount of gold coins owned ({0}) and 10 minutes of taxes at maximum food production ({1})',
  },
  screwdriver: {name: 'Screwdriver'},

  energyDrink: {
    name: 'Energy drink',
    active: 'Full of energy',
    description: 'Refresh combat actives',
    formula: 'Reset the cooldown of all combat actives ({0}) and restart the current fight'
  },

  lightningRod: {
    name: 'Lightning rod',
    active: 'Thunderstorm',
    description: 'Maximize care bonuses',
    formula: 'Consume {0} rainwater ({1}% of what would be required manually) to maximize all care bonuses',
  },
  goldenCarrot: {name: 'Golden carrot'},
  goldenApple: {name: 'Golden apple'},
  popcorn: {name: 'Popcorn'},
  roseQuartz: {name: 'Rose quartz'},
  goldenSeed: {name: 'Golden seed'},

  lightbulb: {name: 'Lightbulb'},
  fishbowl: {name: 'Fishbowl'},
  pencil: {name: 'Pencil'},
  smallBrush: {
    name: 'Small brush',
    active: 'Paint special shape',
    description: 'Create a random special shape',
  },
  strangePills: {name: 'Strange pills'},
  printingPress: {name: 'Printing press'},

  diamondPickaxe: {name: 'Diamond pickaxe'},
  diamondHammer: {name: 'Diamond hammer'},
  diamondSword: {name: 'Diamond sword'},
  diamondShovel: {name: 'Diamond shovel'},
  diamondBrush: {name: 'Diamond brush'},
  diamondPillar: {name: 'Diamond pillar'},

  tinfoilHat: {name: 'Tinfoil hat'},
  cupOfWater: {name: 'Cup of water'},
  combatStrategy: {name: 'Combat strategy'},
  hundredDollarBill: {name: '100-Dollar bill'},
  hotAirBalloon: {name: 'Hot air balloon'},
  largeClover: {name: 'Large clover'},
  eightBall: {name: '8-ball'},
  youngPig: {name: 'Young pig'},
  silverHorseshoe: {name: 'Silver horseshoe'},
  bronzeTools: {name: 'Bronze tools'},
  minersHat: {name: 'Miners hat'},
  dictionary: {name: 'Dictionary'},
  expertTools: {name: 'Expert tools'},
  bloodBag: {name: 'Blood bag'},
  geode: {name: 'Geode'},
  birthdayCake: {name: 'Birthday cake'},
  colorfulFlower: {name: 'Colorful flower'},
  heatingBulb: {name: 'Heating bulb'},
  trashCan: {name: 'Trash can'},
  suitcase: {name: 'Suitcase'},
  tropicalTent: {name: 'Tropical tent'},
  fruitBasket: {name: 'Fruit basket'},
  massiveGrain: {name: 'Massive grain'},
  enchantedBottle: {name: 'Enchanted bottle'},
  moneyGift: {name: 'Money gift'},
  frozenCarrot: {name: 'Frozen carrot'},
};
